import { fromJS, List, Map } from 'immutable';

export function request(state, { data }) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { id }) {
    return state
        .deleteIn([ 'items', id ])
        .set('state', 'FINISHED');
}

export function error(state, { errors }) {
    return state.set('state', 'ERROR');
}
